import React, { useState } from "react";
import dayjs from "dayjs";
import NetaqInput from "./NetaqInput";
import ActionButton from "./ActionButton";
import { useDispatch, useSelector } from 'react-redux';
import { resetFilter } from "../Redux/Auctions/AuctionsSlice";
import { fetchAuctions } from '../Redux/Auctions/AuctionActions';
import { useTranslate } from "./TranslationText";
import SubmitBtn from "./SubmitBtn";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";
import { toSafeISOString } from "../helper/timeUtils";

const MIN_AUCTION_PAST_DATE = dayjs('2000-01-01');

const AuctionFilter = ({ onSubmit }) => {
  const [checker, setChecker] = useState(true);
  const accessToken = localStorage.getItem("accessTokenforEAHS");
  const { translate } = useTranslate();
  const currentLanguage = localStorage.getItem('eahsLang');


  const [filterState, setFilterState] = useState({
    // Initial filter values
    auctionName: "",
    auctionType: "None",
    auctionStartDateFrom: "",
    auctionStartDateTo: "",
    skip: 0,
    take: 6,
    numberOfHorsesFrom: 1,
    numberOfHorsesTo: 50,
    dateRange: "LiveAndHybrid",
    enrolledAuction: false,
  });

  const dispatch = useDispatch();
  const [auctionStartFrom, setAuctionStartFrom] = useState(null);
  const [auctionStartTo, setAuctionStartTo] = useState(null);

  const isUpcoming = filterState.dateRange === "Upcoming";
  const minAuctionDate = isUpcoming ? dayjs() : MIN_AUCTION_PAST_DATE;
  const maxAuctionDate = isUpcoming ? dayjs().add(2, 'year') : dayjs();

  const handleChange = (event, input) => {
    if (!!input && input === "auctionStartDateFrom") {
      let val = event;
      if (val && dayjs(val).isValid()) {
        if (dayjs(val).isBefore(minAuctionDate, 'day')) {
          val = minAuctionDate;
        } else if (dayjs(val).isAfter(maxAuctionDate, 'day')) {
          val = maxAuctionDate;
        }

        if (auctionStartTo && dayjs(val).isAfter(dayjs(auctionStartTo), 'day')) {
          setAuctionStartTo(null);
          setFilterState(prev => ({
            ...prev,
            auctionStartDateFrom: toSafeISOString(val) ?? "",
            auctionStartDateTo: "",
          }));
          setAuctionStartFrom(val);
          return;
        }
      }

      setAuctionStartFrom(val);
      setFilterState(prev => ({
        ...prev,
        auctionStartDateFrom: toSafeISOString(val) ?? "",
      }));

      window.auctionFilter = {
        auctionStartFrom: val
      };
      console.debug('auctionFilter::handleChange::: %o', val);
      return;
    }
    if (!!input && input === "auctionStartDateTo") {
      let val = event;
      if (val && dayjs(val).isValid()) {
        if (dayjs(val).isBefore(minAuctionDate, 'day')) {
          val = minAuctionDate;
        } else if (dayjs(val).isAfter(maxAuctionDate, 'day')) {
          val = maxAuctionDate;
        }

        if (auctionStartFrom && dayjs(val).isBefore(dayjs(auctionStartFrom), 'day')) {
          val = auctionStartFrom;
        }
      }

      setAuctionStartTo(val);
      setFilterState(prev => ({
        ...prev,
        auctionStartDateTo: toSafeISOString(val) ?? "",
      }));
      return;
    }

    if (event.target.name === "dateRange") {
      const newRange = event.target.value;
      const willBeUpcoming = newRange === "Upcoming";
      const newMinDate = willBeUpcoming ? dayjs() : MIN_AUCTION_PAST_DATE;
      const newMaxDate = willBeUpcoming ? dayjs().add(2, 'year') : dayjs();

      let newFrom = auctionStartFrom;
      let newTo = auctionStartTo;

      if (newFrom && dayjs(newFrom).isValid()) {
        if (dayjs(newFrom).isBefore(newMinDate, 'day') || dayjs(newFrom).isAfter(newMaxDate, 'day')) {
          newFrom = null;
        }
      }
      if (newTo && dayjs(newTo).isValid()) {
        if (dayjs(newTo).isBefore(newMinDate, 'day') || dayjs(newTo).isAfter(newMaxDate, 'day')) {
          newTo = null;
        }
      }

      setAuctionStartFrom(newFrom);
      setAuctionStartTo(newTo);
      setFilterState(prev => ({
        ...prev,
        dateRange: newRange,
        auctionStartDateFrom: toSafeISOString(newFrom) ?? "",
        auctionStartDateTo: toSafeISOString(newTo) ?? "",
      }));
      return;
    }

    if (event.target.name === "numberOfHorsesFrom" || event.target.name === "numberOfHorsesTo") {
      const rawVal = event.target.value;
      const numVal = rawVal === "" ? "" : Math.max(0, parseInt(rawVal, 10) || 0);
      setFilterState(prev => ({
        ...prev,
        [event.target.name]: numVal,
      }));
      return;
    }

    const value = event.target.type == 'checkbox' ? event.target.checked : event.target.value;
    setFilterState(prev => ({
      ...prev,
      [event.target.name]: value,
    }));
  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    const finalState = {
      ...filterState,
      numberOfHorsesFrom: filterState.numberOfHorsesFrom === "" ? 0 : Number(filterState.numberOfHorsesFrom),
      numberOfHorsesTo: filterState.numberOfHorsesTo === "" ? 0 : Number(filterState.numberOfHorsesTo),
    };
    onSubmit(finalState);
  };
  const handleReset = (event) => {
    setAuctionStartFrom(null);
    setAuctionStartTo(null);
    setFilterState({
      auctionName: "",
      auctionType: "None",
      auctionStartDateFrom: "",
      auctionStartDateTo: "",
      skip: 0,
      take: 0,
      numberOfHorsesFrom: 1,
      numberOfHorsesTo: 50,
      dateRange: "LiveAndHybrid",
      enrolledAuction: false,
    });
  };



  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={'auctionName'}
          label={translate("web.auctionName", "auction Name")}
          key={"search"}
          placeholder={translate("web.auctionName", "Auction Name")}
          type={"text"}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group">

        {accessToken != null && accessToken !== "" && (
          <NetaqInput
            name={"enrolledAuction"}
            key={"enrolledAuction"}
            type={"checkbox"}
            checked={filterState.enrolledAuction}
            label={translate('web.enrolledAuctionWithQuestionMark', "Enrolled Auction?")}
            onChange={handleChange}
          />
        )}
      </div>
      <div className="mb-form-group">
        <label>
          {translate('web.auctionStage', 'Auction Stage')}
        </label>
        <div className="AuctionFilterRadioContainer">
          <NetaqInput
            name={"dateRange"}
            key={"Running"}
            type={"radio"}
            value={"LiveAndHybrid"}
            label={translate("web.running", "Running")}
            onChange={handleChange}
            checked={filterState.dateRange === "LiveAndHybrid"}
          />
          <NetaqInput
            name={"dateRange"}
            key={"Upcoming"}
            type={"radio"}
            value={"Upcoming"}
            label={translate("web.upcoming", "Upcoming")}
            onChange={handleChange}
            checked={filterState.dateRange === "Upcoming"}
          />

          <NetaqInput
            name={"dateRange"}
            key={"Past"}
            type={"radio"}
            value={"Past"}
            label={translate("web.past", "Past")}
            onChange={handleChange}
            checked={filterState.dateRange === "Past"}
          />
        </div>
      </div>

      <div className="mb-form-group">
        <label>
          {translate('web.numberOfHorses', 'Number of horses')}
        </label>
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"numberOfHorsesFrom"}
              key={"numberOfHoursesfrom"}
              type={"number"}
              value={filterState.numberOfHorsesFrom}
              label={translate("web.from", "From")}
              onChange={handleChange}
              minValue={1}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"numberOfHorsesTo"}
              key={"numberOfHoursesto"}
              type={"number"}
              value={filterState.numberOfHorsesTo}
              label={translate("web.to", "To")}
              onChange={handleChange}
              minValue={filterState.numberOfHorsesFrom || 1}
            />
          </div>
        </div>
      </div>
      <div className="mb-form-group-last">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"auctionStartDateFrom"}
              key={"auction-starting-date"}
              type={"date"}
              label={<>
                {translate("web.date", "Date")} {translate("web.from", "From")}
              </>
              }
              onChange={handleChange}
              value={auctionStartFrom}
              minDate={minAuctionDate}
              maxDate={auctionStartTo && dayjs(auctionStartTo).isBefore(maxAuctionDate, 'day') ? auctionStartTo : maxAuctionDate}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"auctionStartDateTo"}
              key={"auction-end-date"}
              type={"date"}
              label={<>
                {translate("web.date", "Date")} {translate("web.to", "To")}
              </>
              }
              onChange={handleChange}
              value={auctionStartTo}
              minDate={auctionStartFrom || minAuctionDate}
              maxDate={maxAuctionDate}
            />
          </div>
        </div>
      </div>
      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          />
        </div>
      </div>
    </form>
  );
};

export default AuctionFilter;
